export var MuiIconButton = {
  styleOverrides: {
    root: {
      "&:hover": {
        backgroundColor: 'transparent'
      }
    }
  }
};
//# sourceMappingURL=MuiIconButton.js.map